import { Component, inject, OnInit } from '@angular/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { StateService } from '@uirouter/core';
import {
  ModalHeaderButtonsComponent,
  ModalHeaderCloseButtonComponent,
  ModalHeaderComponent,
  ModalHeaderTitleComponent
} from '@tdwb/core';
import { OldAmexNyseComponent } from './old-amex-nyse.component';
import { OldCegComponent } from './old-ceg.component';
import { OldNasdaqComponent } from './old-nasdaq.component';

@Component({
  selector: 'td-wb-old-agreements-modal',
  templateUrl: './old-agreements.modal.component.html',
  styleUrls: ['./old-agreements.modal.component.scss'],
  imports: [
    ModalHeaderComponent,
    ModalHeaderTitleComponent,
    ModalHeaderButtonsComponent,
    ModalHeaderCloseButtonComponent,
    OldAmexNyseComponent,
    OldCegComponent,
    OldNasdaqComponent
  ]
})
export class OldAgreementsModalComponent implements OnInit {
  agreementType: string;

  private readonly stateService = inject(StateService);

  ngOnInit(): void {
    this.agreementType = this.stateService.params['agreementType'] as string;
  }
}
